module.exports = function(app) {

    app.filter('phoneNumber', function() {

        return function (phoneNumber) {
            if (!phoneNumber) { return ''; }

            var value = phoneNumber.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return phoneNumber;
            }

            var area, city, number;

            switch (value.length) {
                case 10:
                    area = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11:
                    area = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12:
                    area = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                default:
                    return phoneNumber;
            }

            if (area == 1) {
                area = "";
            }

            number = number.slice(0, 3) + '-' + number.slice(3);

            return (area + city + "-" + number).trim();
        };
    })
};